import script from "./goodsPointsRecords.vue?vue&type=script&setup=true&lang=js"
export * from "./goodsPointsRecords.vue?vue&type=script&setup=true&lang=js"

import "./goodsPointsRecords.vue?vue&type=style&index=0&id=e6fed09c&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e6fed09c"]])

export default __exports__